import { render, staticRenderFns } from "./VxUploadPopup.vue?vue&type=template&id=24ca85e9&scoped=true"
import script from "./VxUploadPopup.vue?vue&type=script&lang=js"
export * from "./VxUploadPopup.vue?vue&type=script&lang=js"
import style0 from "./VxUploadPopup.vue?vue&type=style&index=0&id=24ca85e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ca85e9",
  null
  
)

export default component.exports